<!-- Added id as dynamic field as one view we have approve/reject button i,e 2 times this button will show and
  to highlight clicked button automatically we need id and target different for each action  -->
<p-button
  test-id="approval-action-request-approval"
  [buttonProps]="{ autofocus: false }"
  [loading]="requestApprovalPopup.isLoading()"
  [disabled]="requestApprovalPopup.isLoading()"
  (click)="onShowRequestApprovalPopup()"
  label="Request Approval" />

@if (requestApprovalPopup.isVisible() && workflow()) {
  <cor-dialog-box
    [(visible)]="requestApprovalPopup.isVisible"
    title="Request Approval"
    (onHide)="onCancelClick()">
    <form
      [formGroup]="form"
      (ngSubmit)="onSubmitClick()">
      <div class="tw:mb-2">
        <strong>Approval Workflow: {{ workflow().name }}</strong>
      </div>
      <div class="tw:flex tw:flex-col tw:md:flex-row align-md-items-center">
        <cor-input-container
          class="tw:grow"
          label="Approval Responsibility"
          test-id="responsibilities">
          <p-select
            test-id="approval-action-responsibility-id"
            [options]="workflow().responsibilities"
            [showClear]="true"
            placeholder="Select a responsibility to request approval from"
            [formControl]="form.controls.responsibilityId"
            optionLabel="name"
            optionValue="id"
            filterBy="name"
            appendTo="body" />
        </cor-input-container>
      </div>

      <cor-input-container
        label="Comment"
        helperText="Paste, drop, or press / to add files. Paste links to supporting analytics like simulations or test-sessions"
        test-id="comment">
        <cor-description
          test-id="approval-action-comment"
          [minHeight]="100"
          placeholder="Here you can put a brief comment"
          [formControl]="form.controls.comment" />
      </cor-input-container>
    </form>

    <ng-template #footer>
      <div class="tw:flex tw:gap-2 tw:items-center">
        <p-button
          test-id="approval-action-cancel-changes"
          [buttonProps]="{ autofocus: false }"
          (click)="onCancelClick()"
          severity="secondary"
          label="Cancel Changes" />
        <p-button
          test-id="approval-action-save-changes"
          [buttonProps]="{ autofocus: false }"
          [loading]="isSaving()"
          [disabled]="isSaving()"
          (click)="onSubmitClick()"
          [label]="isSaving() ? 'Saving...' : 'Save Changes'" />
      </div>
    </ng-template>
  </cor-dialog-box>
}

<!-- Batch approval popup -->
<cor-dialog-box
  [(visible)]="isBatchApprovalPopupVisible"
  [title]="isPendingApprovalPresent() ? batchApprovalPopupTitle() : 'Confirmation'"
  (onHide)="onBatchApprovalPopupCancelClick()">
  @if (!isPendingApprovalPresent()) {
    <h6 class="tw:mb-4">
      {{
        `Some of the inputs of this ${OBJECT_DISPLAY_NAMES[object()]}
      are still in Draft status.`
      }}
      <br />
      Do you want to request approval for those as well?
    </h6>
  } @else {
    <h6 class="tw:mb-4">
      Approval process can start only with Draft or Approved inputs. Below
      <span [ngPlural]="approvalSequence.length">
        <ng-template ngPluralCase="=1">input</ng-template>
        <ng-template ngPluralCase="other">inputs</ng-template>
      </span>
      need attention.
    </h6>
  }
  <div class="card max-height-220">
    <dx-data-grid
      columnResizingMode="widget"
      [allowColumnReordering]="true"
      [scrolling]="{ useNative: true }"
      [columnAutoWidth]="true"
      [allowColumnResizing]="true"
      [repaintChangesOnly]="true"
      [showRowLines]="true"
      [showColumnLines]="false"
      [wordWrapEnabled]="true"
      [dataSource]="datasource">
      <dxi-data-grid-column
        [allowSorting]="false"
        caption="Name"
        dataField="name"
        cellTemplate="nameLinkTemplate" />

      <dxi-data-grid-column
        [allowSorting]="false"
        caption="Object Type"
        dataField="objectType"
        cellTemplate="objectTypeTemplate" />

      <dxi-data-grid-column
        [allowSorting]="false"
        caption="Owner"
        dataField="createdByVisibleName" />

      <dxi-data-grid-column
        [allowSorting]="false"
        caption="Workflow Status"
        dataField="currentStatus"
        cellTemplate="statusTemplate" />

      <div
        class="tw:flex"
        *dxTemplate="let data of 'nameLinkTemplate'">
        <a
          test-id="approval-action-span"
          class="tw:truncate"
          [routerLink]="data.data.link"
          title="{{ data.data.name }}"
          [pTooltip]="
            data.data.batchId > 1
              ? 'Depends on one or more draft inputs. Please get the precedents approved'
              : ''
          "
          target="_blank">
          {{ data.data.name }}
        </a>
      </div>

      <div
        class="tw:flex"
        *dxTemplate="let data of 'aliasTemplate'">
        <span
          class="tw:truncate"
          title="{{ data.data.name }}">
          {{ data.data.alias }}
        </span>
      </div>

      <div *dxTemplate="let data of 'objectTypeTemplate'">
        {{ $any(OBJECT_DISPLAY_NAMES)[data.value] }}
      </div>

      <div *dxTemplate="let data of 'statusTemplate'">
        <cor-status-icon [status]="data.value" />
      </div>

      <div *dxTemplate="let data of 'objectTypeTemplate'">
        {{ $any(OBJECT_DISPLAY_NAMES)[data.value] }}
      </div>
    </dx-data-grid>
  </div>

  @if (!isPendingApprovalPresent()) {
    <ng-template #footer>
      <div class="tw:flex tw:gap-2 tw:items-center">
        <p-button
          test-id="approval-action-no"
          [buttonProps]="{ autofocus: false }"
          (click)="onGroupApprovalReject()"
          severity="secondary"
          label="No" />
        <p-button
          test-id="approval-action-yes"
          [buttonProps]="{ autofocus: false }"
          (click)="onGroupApprovalConfirm()"
          label="Yes" />
      </div>
    </ng-template>
  }
</cor-dialog-box>
